import React, {
  useMemo,
  useState,
  forwardRef,
  useImperativeHandle,
  ForwardRefRenderFunction,
} from 'react';
import { Close } from '@mui/icons-material';
import { Rnd, HandleStyles } from 'react-rnd';
import { Box, Paper, Typography } from '@mui/material';

import 'assets/styles/MapPopup.scss';
import { dragAndResizeStyles } from './Helpers/generalHelpers';

interface MapPopupProps {
  title?: string;
  handleClose: () => void;
  cellDetailsOpen: boolean;
  children: React.ReactNode;
  mapPopupStateVisibility: boolean;
}

export interface MapPopupRef {
  isOpen?: boolean;
  handleOpenModal: (isOpen: boolean) => void;
}

const MapPopup: ForwardRefRenderFunction<MapPopupRef, MapPopupProps> = (
  { title, children, handleClose, cellDetailsOpen },
  ref
) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const resizeHandleStyles: HandleStyles = useMemo(
    () => dragAndResizeStyles,
    []
  );

  const handleOpenModal = (isOpen: boolean) => setIsOpen(isOpen);

  useImperativeHandle(ref, () => ({ isOpen, handleOpenModal }));

  if (!isOpen) return <React.Fragment />;

  return (
    <Box
      className={`map-component-popup ${
        cellDetailsOpen ? 'resize-map-component-popup' : ''
      }`}
    >
      <Rnd
        dragHandleClassName="map-popup-header"
        default={{ height: 540, width: 900, y: -270, x: -30 }}
        minWidth={617}
        minHeight={300}
        resizeHandleStyles={resizeHandleStyles}
      >
        <Box component={Paper}>
          <Box className="map-popup-header">
            <Close onClick={handleClose} className="close-markers" />
            <Typography id="modal-modal-title" variant="h6" component="h2">
              {title}
            </Typography>
          </Box>
          {children}
        </Box>
      </Rnd>
    </Box>
  );
};

export default forwardRef<MapPopupRef, MapPopupProps>(MapPopup);
